<hr style="margin-top: 0.1rem;">

<div class="geomap-page">

  <!-- Same selection panel as Analyze Sensor Readings -->
  <kig-sensor-reading-selector
      [showReadingSourceOptions]="false"
      (selectionChanged)="onSelectionChanged($event)"
      (refreshRequested)="refreshReadings()">
  </kig-sensor-reading-selector>

  <div class="geomap-main">
    <kig-map-favorite-bar class="geomap-toolbar"
        [username]="username"
        [globalSwitch]="globalSwitch"
        [canSave]="isMapFavoriteReadyToSave()"
        [selected]="selectedMapFavorite"
        [rememberedId]="favoriteIdToSelectAfterLoad"
        [linkedFavoriteId]="linkedMapFavoriteId"
        [snapshot]="favoriteSnapshot"
        (favoriteApplied)="applyFavorite($event)"
        (selectedChange)="onFavoriteSelected($event)">
    </kig-map-favorite-bar>

    <div class="geomap-map">
      <kig-map-favorite
          [sensors]="mapSensors"
          [sensorReadings]="mapReadings"
          [savedMapDetails]="mapSavedDetails"
          [mapFavoriteId]="selectedMapFavorite?.id || 0"
          [labelsEditable]="isUpdate()"
          [username]="username"
          (mapDetailsChanged)="onMapDetailsChanged($event)">
      </kig-map-favorite>
    </div>
  </div>
</div>
